var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.855,
    height: 29.026,
    viewBox: "0 0 33.855 29.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(-157.778 -626.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M157.778,640.807h4.81a14.43,14.43,0,0,1,5.4-11.27A13.97,13.97,0,0,1,177.1,626.3a14.5,14.5,0,1,1-10.172,24.778l2.262-2.263a11.119,11.119,0,0,0,9.049,3.207,10.876,10.876,0,0,0,6.865-3.258,11.263,11.263,0,1,0-19.231-7.964h4.715l.09.113-6.493,6.32c-.3-.306-.632-.639-.963-.97q-2.582-2.583-5.166-5.164a3.26,3.26,0,0,0-.276-.223Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M353.1,721.812l-1.154,1.945c-.091-.045-.169-.078-.241-.121q-3.22-1.909-6.44-3.818a.391.391,0,0,1-.243-.377c.009-2.543.006-5.086.007-7.629,0-.054.009-.108.016-.188h2.419V712c0,2.048,0,4.1-.006,6.143a.492.492,0,0,0,.284.491c1.688.99,3.369,1.992,5.051,2.99C352.885,721.68,352.978,721.738,353.1,721.812Z",
    transform: "translate(-169.526 -77.253)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupm);
export default __webpack_public_path__ + "static/media/Groupm.4a66d15c83e3b20df8fd09ab68310835.svg";
export { ForwardRef as ReactComponent };